"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FeaturesActionTypes;

(function (FeaturesActionTypes) {
  FeaturesActionTypes["DYNAMYND_SET_FEATURE_FLAGS"] = "[dynamynd] set the values for the feature flags";
})(FeaturesActionTypes = exports.FeaturesActionTypes || (exports.FeaturesActionTypes = {}));